import { Box, Divider, List, Typography } from '@mui/material';
import React from 'react';
import styles from './InvoiceViewLineItems.module.scss';
import { InvoiceViewLineItem } from './InvoiceViewLineItem';
import { gql, DocumentNode } from '@apollo/client';
import rpcShared from '@rockpapercoin/rpc-shared';
import { useDeviceDetection } from '../../../hooks/useDeviceDetection';
import { InvoiceViewLineItemsInvoiceFragment } from '#types';

export const invoiceViewLineItemsInvoiceFragment = gql`
	fragment invoiceViewLineItemsInvoice on Invoice {
		id
		organization {
			id
			country
		}
		lineItems {
			id
			name
			quantity
			rate
			taxPercentage
			notes
		}
	}
`;

export type InvoiceViewLineItemsProps = {
	invoice?: InvoiceViewLineItemsInvoiceFragment;
};

type InvoiceViewLineItemsPropsWithFragment =
	React.FC<InvoiceViewLineItemsProps> & {
		fragments: {
			invoiceViewLineItemsInvoiceFragment: DocumentNode;
		};
	};

export const InvoiceViewLineItems: InvoiceViewLineItemsPropsWithFragment = ( {
	invoice,
} ) => {
	const lineItems = invoice?.lineItems?.map( ( lineItem ) =>
		rpcShared.invoices.calculateLineItemToString( invoice, lineItem )
	);
	const { isMobile } = useDeviceDetection();
	const currencyLabel = rpcShared.invoices.getCurrencyLabel(
		invoice?.organization?.country
	);
	const rateLabel = `Rate${ currencyLabel }`;
	return (
		<Box className={ styles.container } data-cy='line-items'>
			<Typography variant='h6' className={ styles.title }>
				Invoice line items
			</Typography>
			<Box className={ styles.header } data-cy='line-items-header'>
				{ isMobile ? (
					<Typography component='div'>Items</Typography>
				) : (
					<>
						<Typography component='div'>Name</Typography>
						<Typography component='div'>{ rateLabel }</Typography>
						<Typography component='div'>Quantity</Typography>
						<Typography component='div'>Tax</Typography>
						<Typography component='div'>Line total</Typography>
					</>
				) }
			</Box>
			<Divider />
			<List disablePadding data-cy='line-items-list'>
				{ lineItems?.map( ( lineItem ) =>
					lineItem ? (
						<InvoiceViewLineItem
							key={ lineItem.id }
							lineItem={ lineItem }
							isMobile={ isMobile }
							rateLabel={ rateLabel }
						/>
					) : null
				) }
			</List>
		</Box>
	);
};

InvoiceViewLineItems.fragments = {
	invoiceViewLineItemsInvoiceFragment,
};
